<template>
  <div class="park-detail">
    <div class="park-detail-base">
      <div class="park-detail-base-img">
        <div :class="['swiper', 'mySwiper2', 'mySwiper2_' + parkId]">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in parkDetailData.pronounceImages"
              :key="index"
              :src="imgUrl + item.filePath"
              @click="handleLook(parkDetailData.pronounceImages, index)"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
        </div>
        <div :class="['swiper', 'mySwiper', 'mySwiper_' + parkId]">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in parkDetailData.pronounceImages"
              :key="index"
              :src="imgUrl + item.filePath"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
          <div class="swiper-button-prev m-swiper-button" />
          <div class="swiper-button-next m-swiper-button" />
        </div>
      </div>
      <div class="park-detail-base-content">
        <div class="park-detail-base-content-price">
          <div class="park-detail-base-content-price-text">
            {{ parkDetailData.name }}
          </div>
          <div class="park-detail-base-content-price-span">
            浏览：{{ parkDetailData.statistical }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系人</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ parkDetailData.person }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系方式</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ parkDetailData.phone }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">园区级别</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ parkDetailData.parkLevelName }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">园区面积</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ parkDetailData.actualAreaActual }}公顷
          </div>
        </div>
        <div class="park-detail-base-content-info grid-single-line">
          <div class="park-detail-base-content-info-key">
            基础设施: {{ parkDetailData.infrastructureName }} (
            {{ parkDetailData.infrastructureStr }})
          </div>
          <div
            class="park-detail-base-content-info-value info-value-text2"
          ></div>
        </div>
        <!-- <div class="park-detail-base-content-info grid-single-line">
          <div class="park-detail-base-content-info-key">园区位置</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ parkDetailData.locationActual }}
          </div>
        </div> -->
        <div class="park-detail-base-content-info grid-single-line">
          <div class="park-detail-base-content-info-key">产业类型</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ parkDetailData.leadingIndustry }}
          </div>
        </div>
      </div>
    </div>
    <div class="park-detail-info">
      <div class="park-detail-info-content">
        <!-- <div class="park-detail-info-content-nav">
          <div
            class="park-detail-info-content-nav-item"
            style="color: #1c4eb0"
            @click="scrollView('#investment')"
          >
            招商信息
          </div>
          <div
            class="park-detail-info-content-nav-item"
            @click="scrollView('#info-park')"
          >
            园区详情
          </div>
          <div
            class="park-detail-info-content-nav-item"
            @click="scrollView('#parkPlace')"
          >
            位置
          </div>
        </div> -->
        <div id="investment" class="park-detail-info-investment">
          <div class="park-detail-info-sub-title">◇招商信息</div>
          <div class="info-content scrollbar-definition" v-html="info"></div>
          <!-- <div class="park-detail-info-investment-content">
            <table class="park-detail-info-investment-content-table" border="1">
              <colgroup>
                <col class="park-detail-info-investment-content-table-c1" />
                <col />
              </colgroup>
              <tr>
                <td class="park-detail-info-investment-content-table-key">
                  招商政策
                </td>
                <td class="park-detail-info-investment-content-table-value">
                  {{ parkDetailData.investmentPolicy }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-info-investment-content-table-key">
                  项目情况
                </td>
                <td class="park-detail-info-investment-content-table-value">
                  {{ parkDetailData.projectSituation }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-info-investment-content-table-key">
                  招商需求
                </td>
                <td class="park-detail-info-investment-content-table-value">
                  {{ parkDetailData.investmentDemand }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-info-investment-content-table-key">
                  人才情况
                </td>
                <td class="park-detail-info-investment-content-table-value">
                  {{ parkDetailData.talentSituation }}
                </td>
              </tr>
            </table>
          </div> -->
          <div
            v-if="parkDetailData.pronounceVideos?.length"
            class="park-detail-info-investment-video"
          >
            <div
              v-for="(item, index) of parkDetailData.pronounceVideos"
              :key="index"
              class="park-detail-info-investment-video-item"
              @click="playVideos(item)"
            >
              <div class="park-detail-info-investment-video-item-thumbnail">
                <el-image
                  :src="imgUrl + item.thumbnail"
                  fit="cover"
                  class="park-detail-info-investment-video-item-thumbnail-img"
                />
                <el-image
                  :src="require('@/assets/images/common/视频播放.png')"
                  fit="cover"
                  class="park-detail-info-investment-video-item-thumbnail-action"
                />
              </div>
              <div class="park-detail-info-investment-video-item-title">
                {{ item.fileTitle }}
              </div>
            </div>
          </div>
          <div
            v-if="parkDetailData.pronounceImages?.length"
            class="park-detail-info-investment-image"
          >
            <div
              v-for="(item, index) of parkDetailData.pronounceImages"
              :key="index"
              class="park-detail-info-investment-image-item"
              @click="handleLook(parkDetailData.pronounceImages, index)"
            >
              <el-image
                :src="imgUrl + item.filePath"
                fit="cover"
                class="park-detail-info-investment-image-item-img"
              />
              <div class="park-detail-info-investment-image-item-title">
                {{ item.fileTitle }}
              </div>
            </div>
          </div>
          <div
            v-if="parkDetailData.attachmentFiles?.length"
            class="park-detail-info-investment-file"
          >
            <div
              class="park-detail-info-investment-file-li"
              v-for="(item, index) of parkDetailData.attachmentFiles"
              :key="index"
              @click="previewOrDownFile(item.filePath)"
            >
              <div><img :src="getFileIconUrl(item.suffix)" alt="" /></div>
              <div class="park-detail-info-investment-image-item-title">
                {{ item.fileTitle }}
              </div>
            </div>
          </div>
        </div>
        <div id="info-park" class="park-detail-info-park">
          <div class="park-detail-info-sub-title">◇园区详情</div>

          <div class="park-detail-info-park-content">
            <table border="1" class="park-detail-table">
              <tr>
                <td colspan="4" class="park-detail-table-header">批准范围</td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区名称</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.name }}
                </td>
                <td class="park-detail-table-key1">园区面积</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.actualAreaActual }}公顷
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">行政区划</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.countyName }}
                </td>
                <td class="park-detail-table-key1">规划建设用地面积</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.planArea }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区级别</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.parkLevelName }}
                </td>
                <td class="park-detail-table-key1">已批准征收土地面积</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.levyArea }}公顷
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区评价类</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.parkType }}
                </td>
                <td class="park-detail-table-key1">已批准转用土地面积</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.diversionArea }}公顷
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">主导产业</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.leadingIndustry }}
                </td>
                <td class="park-detail-table-key1">批而未供土地面积</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.approvalNotProvide }}公顷
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区代码</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.parkCode }}
                </td>
                <td class="park-detail-table-key1">二、三产业税收总额</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.secondThirdTotal }}万元
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">设立时间</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.setTime }}
                </td>
                <td class="park-detail-table-key1">
                  工业（物流）企业固定资产投资额
                </td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.industrialFixed }}万元
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">审批类型</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.approvalType }}
                </td>
                <td class="park-detail-table-key1">工业（物流）企业总收入</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.industrialTotal }}万元
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区联系方式</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.parkPhone }}
                </td>
                <td class="park-detail-table-key1">工业（物流）企业税收总额</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.industrialRevenue }}万元
                </td>
              </tr>

              <tr>
                <td colspan="4" class="park-detail-table-header">
                  实际管理范围
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区名称</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.name }}
                </td>
                <td class="park-detail-table-key1">园区代码</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.parkCodeActual }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">行政区划</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.countyName }}
                </td>
                <td class="park-detail-table-key1">设立时间</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.setTimeActual }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区级别</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.parkLevelName }}
                </td>
                <td class="park-detail-table-key1">审批类型</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.approvalType }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">园区评价类</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.parkType }}
                </td>
                <td class="park-detail-table-key1">园区联系方式</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.parkPhoneActual }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">主导产业</td>
                <td class="park-detail-table-value">
                  {{ parkDetailData.leadingIndustry }}
                </td>
                <td class="park-detail-table-key1">园区面积</td>
                <td class="park-detail-table-value1">
                  {{ parkDetailData.actualAreaActual }}公顷
                </td>
              </tr>
            </table>
          </div>
        </div>

        <park-place
          id="parkPlace"
          :park-code-actual="parkDetailData.parkCodeActual"
          :park-id="parkDetailData.id"
        />
      </div>
      <video-dialog
        :visible="playVideo.show"
        :videoSrc="playVideo.src"
        :videoTitle="playVideo.title"
        @onCloseVideo="playVideo.show = false"
      />
      <el-image-viewer
        v-if="previewImage.show"
        :url-list="previewImage.urlList"
        :initial-index="previewImage.index"
        :on-close="() => (previewImage.show = false)"
        style="z-index: 9999"
      />
    </div>
  </div>
</template>

<script>
import ParkPlace from "@/views/park/components/ParkPlace";
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.min.css";
import VideoDialog from "@/components/currency/videoDialog";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { getParkDetail } from "@/api/setting/investment";

/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/15 16:38
 * @Description 园区详情
 */
export default {
  name: "parkDetail",
  components: { ElImageViewer, ParkPlace, VideoDialog },
  props: {
    parkId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      parkDetailData: {},
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      playVideo: {
        show: false,
        src: undefined,
        title: undefined,
      },
      previewImage: {
        show: false,
        urlList: [],
        index: 0,
      },
      infrastructureConfigList: [
        {
          value: "1",
          label: "土地平整",
        },
        {
          value: "2",
          label: "通雨水管线",
        },
        {
          value: "3",
          label: "通污水管线",
        },
        {
          value: "4",
          label: "通电信管道及电缆",
        },
        {
          value: "5",
          label: " 通热力管线",
        },
        {
          value: "6",
          label: "通电力管线",
        },
        {
          value: "7",
          label: "通自来水管线",
        },
        {
          value: "8",
          label: "通天然气管线",
        },
        {
          value: "9",
          label: "通有线电视线光缆",
        },
        {
          value: "10",
          label: "通道路",
        },
      ],
      info: "",
    };
  },
  mounted() {
    this.getetial(this.parkId);
  },
  methods: {
    getetial(id) {
      getParkDetail(id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let infrastructure = "";
          if (data.infrastructureList.length) {
            data.infrastructureList.forEach((item, index) => {
              let obj = this.infrastructureConfigList.find(
                (inItem) => inItem.value == item
              );
              if (index == 0) {
                infrastructure = obj.label;
              } else {
                infrastructure = infrastructure + "，" + obj.label;
              }
            });
          }
          this.$set(data, "infrastructureStr", infrastructure);
          let info = ``;
          if (data.investmentPolicy) {
            let str = `<h4>招商政策</h4>`;
            info = info + str + data.investmentPolicy;
          }
          if (data.investmentDemand) {
            let str = `<h4>招商需求</h4>`;
            info = info + str + data.investmentDemand;
          }
          if (data.industrialChain) {
            let str = `<h4>产业链</h4>`;
            info = info + str + data.industrialChain;
          }
          if (data.talentSituation) {
            let str = `<h4>人才情况</h4>`;
            info = info + str + data.talentSituation;
          }
          if (data.landSituation) {
            let str = `<h4>用地情况</h4>`;
            info = info + str + data.landSituation;
          }
          this.info = info;
          this.parkDetailData = data;
          this.setSwiper();
        }
      });
    },
    getFileIconUrl(fileSuffix) {
      let iconUrl;
      switch (fileSuffix) {
        case "pdf":
          iconUrl = require("@/assets/images/common/文件-pdf.png");
          break;
        case "doc":
        case "docx":
          iconUrl = require("@/assets/images/common/文件-word.png");
          break;
        case "zip":
        case "rar":
          iconUrl = require("@/assets/images/common/文件-压缩包.png");
          break;
        case "xls":
        case "xlsx":
          iconUrl = require("@/assets/images/common/excel.png");
          break;
        default:
          iconUrl = require("@/assets/images/common/文件-其它.jpg");
      }
      return iconUrl;
    },
    setSwiper() {
      let swiper = new Swiper(`.mySwiper_${this.parkId}`, {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      let swiper2 = new Swiper(`.mySwiper2_${this.parkId}`, {
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: swiper,
        },
      });
    },
    scrollView(selector) {
      document.querySelector(selector).scrollIntoView();
    },
    previewOrDownFile(url) {
      window.open(this.imgUrl + url);
    },
    //播放视频
    playVideos(file) {
      this.playVideo.show = true;
      this.playVideo.src =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.playVideo.title = file.fileTitle || "";
    },
    //查看图片
    handleLook(list, index) {
      this.previewImage.urlList = [];
      list.forEach((item) => {
        this.previewImage.urlList.push(this.imgUrl + item.filePath);
      });
      this.previewImage.index = index;
      this.previewImage.show = true;
    },
  },
};
</script>

<style scoped>
.park-detail {
  /* width: 60%;
  margin: 0 auto 10px; */
  width: 100%;
  padding: 10px 20px;
}

.park-detail-title {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e0e0e0;
  padding: 4px 2px 4px 0;
}

.park-detail-title-text {
  font-size: 1rem;
  font-weight: 600;
  flex-grow: 1;
}

.park-detail-title-browse-count {
  font-size: 0.75rem;
  color: #8a8a8a;
  align-self: flex-end;
  flex-shrink: 0;
}

.park-detail-base {
  display: flex;
  column-gap: 20px;
}

.park-detail-base-img {
  width: 50%;
  height: 300px;
}

.park-detail-base-content {
  width: 50%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px 10px;
  font-size: 0.85rem;
}

.park-detail-base-content-price {
  grid-column: 1 / -1;
  padding: 8px 4px;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.park-detail-base-content-price-text {
  font-weight: bold;
  font-size: 1rem;
}
.park-detail-base-content-price-span {
  font-size: 0.75rem;
  color: #837a7a;
}

.park-detail-base-content-info {
}

.park-detail-base-content-info-key {
}

.park-detail-base-content-info-value {
}

.info-value-bold {
  font-weight: bold;
}

.info-value-text1 {
  color: #0064fd;
}

.info-value-text2 {
  color: #317dfc;
  font-size: 0.75rem;
}

.info-value-text3 {
  color: #717171;
}

.grid-single-line {
  grid-column: 1 / -1;
}

.park-detail-info {
  margin-top: 20px;
  display: grid;
  column-gap: 20px;
}

.park-detail-info-content-nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 2fr;
  background-color: #f4f4f4;
  padding: 2px;
  cursor: pointer;
}

.info-content {
  max-height: 500px;
  overflow: auto;
  margin: 20px 0;
  line-height: 30px;
  white-space: pre-wrap !important;
}
.park-detail-info-content-nav-item {
}

.park-detail-info-sub-title {
  margin-top: 20px;
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-content {
}

.park-detail-info-investment-content {
  margin-top: 10px;
}

.park-detail-info-investment-content-table {
  width: 100%;
}

.park-detail-info-investment-content > div {
  border: solid 1px #e0e0e0;
}

.park-detail-info-investment-content-table-c1 {
  background-color: #f1f5ff;
  width: calc(100% / 6);
}

.park-detail-info-investment-content-table-key {
  padding: 4px 8px;
  text-align: center;
}

.park-detail-info-investment-content-table-value {
  color: #909090;
  padding: 4px 8px;
}

.park-detail-info-investment-video {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-video-item-thumbnail {
  width: 120px;
  height: 80px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.park-detail-info-investment-video-item-thumbnail-img {
  cursor: pointer;
  grid-column: 1 / -1;
  grid-row: 1 / -1;
}

.park-detail-info-investment-video-item-thumbnail-action {
  grid-column: 2 / 3;
  grid-row: 2 /3;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  color: white;
}

.park-detail-info-investment-video-item-title {
}

.park-detail-info-investment-image {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-image-item-img {
  width: 120px;
  height: 80px;
  cursor: pointer;
}

.park-detail-info-investment-image-item-title {
}

.park-detail-info-investment-file-li {
  width: 120px;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
}

.park-detail-info-investment-file {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border: solid 1px #e5e5e5;
}

.park-detail-info-investment-file-item-img {
  width: 80px;
  height: 80px;
  /* padding: 8px 28px; */
  box-sizing: border-box;
  /* filter: grayscale(1); */
  cursor: pointer;
}

table {
  border: solid 1px #d0d0d0;
  border-spacing: 0;
  border-collapse: collapse;
}

.park-detail-table {
  width: 100%;
  margin: 10px 0;
  text-align: center;
}

.park-detail-table-header {
  background-color: #e6efff;
  color: #105ab5;
  font-weight: 600;
  font-size: 1rem;
  padding: 12px;
}

.park-detail-table-key {
  width: calc(100% / 6);
  padding: 8px;
  color: #000000;
}

.park-detail-table-value {
  width: calc(100% / 6 * 2);
  color: #858585;
  padding: 8px;
}
.park-detail-table-key1 {
  width: calc(100% / 6 * 2);
  color: #000000;
  padding: 8px;
}
.park-detail-table-value1 {
  width: calc(100% / 6);
  color: #858585;
  padding: 8px;
}
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 1.12rem;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: calc(100% / 7 * 5);
  width: 100%;
}

.mySwiper {
  height: calc(100% / 7 * 2);
  box-sizing: border-box;
  padding: 5px 0;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-swiper-button {
  --swiper-navigation-size: 14px;
  color: white;
  background-color: #00000073;
  width: 20px;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
}
>>> .tz-toggle-layout__warp {
  z-index: 1000 !important;
}
</style>
